import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 25,
    marginTop: 20,
    marginBottom: 20,
    width: 350,
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 20,
    color: "#077A97",
    textTransform: "uppercase",
  },

  contentPrice: {
    paddingHorizontal: 25,
    marginTop: 10,
    marginBottom: 26,
    textAlign: "center",
  },
  textPriceLeft: {
    fontSize: 16,
  },
  textPriceRight: {
    fontSize: 16,
    textAlign: "right",
  },
  price: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
  priceSecondary: {
    fontSize: 14,
    fontWeight: "400",
    color: "#656565",
    textAlign: "right",
  },

  contentCheckbox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "90%",
    marginTop: 10,
  },
  confirmDataRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },

  text: {
    flex: 1,
    flexWrap: "wrap",
    fontWeight: "400",
    textTransform: "uppercase",
    fontSize: 12,
  },

  bold: {
    textAlign: "right",
    fontWeight: "bold",
  },

  contentBtn: {
    paddingHorizontal: 25,
    width: "100%",
    marginTop: 20,
  },
  btn: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  hrLine: {
    height: 0.2,
    width: "100%",
    borderWidth: 0.2,
    marginTop: 2,
    marginBottom: 18,
    borderColor: "#077A97",
  },
});

export default styles;
